import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

export interface DialogData { 
  mensaje: string;
}

@Component({
  selector: 'app-alert-refresh',
  templateUrl: './alert-refresh.component.html',
  styleUrls: ['./alert-refresh.component.scss']
})
export class AlertRefreshComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AlertRefreshComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit() {
  }

  onNoClick(){
    this.dialogRef.close();
    location.reload(true);
  }

}

